
<style>


@media (max-width: 767px) and (min-width: 320px) {
  .image404 {
    width: 100%;
    width: -moz-available;
    width: fill-available;
    max-width: 100%;
  }

}



</style>



<div class="container-fluid"
    style="background: url(../../assets/images/editorimages/Mask_group.png) 0 0/100% 100% no-repeat;margin-bottom: -100px;">
    <app-header></app-header>
    <div class="text-center" style="justify-content: center; align-items: center;"> <img
            src="../../assets/images/editorimages/nopagefound.svg" alt="" style=" margin-top: 6%; width: 630px;
" class="image404"> </div>
    <div class="container" style="justify-content: center;font-size: 30px;
    margin-top: 20px;">
        <h1 class="text-center">PAGE NOT FOUND</h1>
        <p style="font-size: 18px;font-weight: 400;line-height: 21.11px;text-align: center;">we couldn't find the page
            you were looking for</p>
    </div>
    <div class="text-center" style="justify-content: center; align-items: center;">
        <button type="button" id="checkgrammar-btn-art" class="btn text-center" [routerLink]="['/']"
            style="margin-bottom: 155px;">Back To Home</button>
    </div>
</div>
<app-footer></app-footer>
